import { CONVERSATION_HREF } from "../lib/site";
import { Body, Em, GOLD, GOLD_DEEP, GhostBtn, GoldBtn, HAIR, Hero, IVORY, Kicker, Ornament, SLATE, Section, Serif, Title } from "../components/ms/kit";
import { useInvite } from "../components/ms/InviteContext";
import PageShell from "../components/ms/PageShell";

const NUMBERS = [
  ["4", "Community hubs: Regina, Saskatoon, Prince Albert and Estevan"],
  ["27", "Sessions across our programs"],
  ["25+", "Speakers and partners"],
  ["1", "Demo Day to close the program"],
];

const Leadership = () => (
  <Section testId="leadership" width="max-w-5xl">
    <div className="grid grid-cols-1 md:grid-cols-[1fr_1.5fr] gap-12 md:gap-20 items-start">
      <div className="md:sticky md:top-28">
        <Kicker>Leadership</Kicker>
        <Title className="mt-6" testId="about-leader-name">Danielle Brewin Graham.</Title>
        <p className="mt-4 text-[11px] tracking-[0.3em] uppercase" style={{ color: GOLD_DEEP }}>Founder</p>
      </div>
      <div className="space-y-7 md:pt-4">
        <Body tone={IVORY}>Danielle has spent her career building the communities and capital that early-stage companies need. She co-founded The Firehood, a national women&apos;s angel network, built the Archangel and Phoenix Fire funds, and led early-stage investment at Ontario Centres of Excellence, now OCI, where she worked with 42 companies. Today she is a General Partner at Maskwa Capital, a founding member of the CSCA, an EIR and Investor Coach at Platform Calgary, and an advisor to ventureLAB&apos;s Capital Investment Program.</Body>
        <Body>Born in Vancouver and raised in Namibia, Ethiopia and Kenya, Danielle brings a global view to building local ecosystems. She holds an MBA in Sustainability and Technology from Wilfrid Laurier University&apos;s Lazaridis School, an MA in African History from Dalhousie University, and an Honours BA in History from Trinity College at the University of Toronto.</Body>
      </div>
    </div>
  </Section>
);

const Numbers = () => (
  <Section testId="by-the-numbers">
    <div className="text-center"><Kicker>By the numbers</Kicker></div>
    <div className="mt-12 grid grid-cols-2 md:grid-cols-4" style={{ borderTop: HAIR, borderLeft: HAIR }}>
      {NUMBERS.map(([n, label]) => (
        <div key={label} className="px-6 py-10 text-center" style={{ borderRight: HAIR, borderBottom: HAIR }}>
          <div style={{ ...Serif, color: GOLD, fontSize: "clamp(2.5rem, 4.5vw, 3.5rem)", lineHeight: 1 }}>{n}</div>
          <div className="mt-5 text-[11px] tracking-[0.2em] uppercase leading-[1.7]" style={{ color: SLATE }}>{label}</div>
        </div>
      ))}
    </div>
  </Section>
);

export default function About() {
  const openInvite = useInvite();
  return (
    <PageShell testId="about-page">
      <Hero kicker="About" testId="about" extra={<Ornament />}
        body="Maven Skies Inc. is incorporated in Saskatchewan and based in Regina, with roots in Alberta and a national outlook. We started on the Prairies because the founders, the investors and the capacity to build are already here. Our work is to connect them, so that more capital is raised, invested and returned in the communities where it is earned.">
        Built on the Prairies, for the people <Em>building them.</Em>
      </Hero>
      <Leadership />
      <Numbers />
      <Section testId="about-closing" className="py-32 md:py-44" width="max-w-3xl">
        <div className="text-center">
          <Title>Let&apos;s build something that <Em>lasts.</Em></Title>
          <div className="mt-12 flex flex-wrap justify-center gap-3">
            <GoldBtn href={CONVERSATION_HREF} testId="about-cta-conversation">Start a Conversation</GoldBtn>
            <GhostBtn onClick={openInvite} testId="about-cta-invite">Request Invitation</GhostBtn>
          </div>
        </div>
      </Section>
    </PageShell>
  );
}
